import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { makeFormField, validatePassword } from '@/helpers';
import { ui } from '@/constants';
import { CustomerError } from '@/services/customer/customer.service';
import { FormType } from '@/models';
import { Routes } from '@/router';

@Component({
  name: 'CmgPasswordResetPage',
})
export default class CmgPasswordResetPage extends Vue {
  password = makeFormField();
  isFormValid = true;
  isSavingNewPassword = false;
  isRequestComplete = false;
  errorMessage = '';

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  validatePassword(): void {
    validatePassword(this.password);
  }

  validateForm() {
    this.errorMessage = '';
    this.isFormValid = true;
    this.validatePassword();

    if (this.password.error) {
      this.password.dirty = true;
      this.isFormValid = false;
    }
  }

  onClickSignIn() {
    this.$services.ui.setModalVisibility('signIn', true, { route: Routes.Home, type: FormType.SignIn, onClose: this.onClickCancel });
    this.$services.ui.firstFocus();
  }

  onClickCancel() {
    this.$router.push({ name: Routes.Order });
  }

  async onSubmit(): Promise<void> {
    this.isSavingNewPassword = true;

    this.validateForm();

    try {
      if (!this.isFormValid) {
        return;
      }
      const queryParamId = this.$route.query.id;

      if (!queryParamId) {
        return;
      }

      await this.$services.customer.resetPasswordRequest({ ResetToken: queryParamId.toString(), NewPassword: this.password.value });

      this.isRequestComplete = true;
    } catch (err) {
      if (err instanceof CustomerError) {
        this.errorMessage = err.message;
      } else {
        throw err;
      }
    } finally {
      this.isSavingNewPassword = false;
    }
  }
}
